import { ChipVariant } from './Chip.types';
import {
  clickableClass,
  nToPx,
  textEllipsisClass,
  themeVars,
  toBorder,
} from '@tundr/theme';
import { style, styleVariants } from '@vanilla-extract/css';

export const chipClass = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: themeVars.space.x2,
  justifyContent: 'center',
  padding: nToPx(themeVars.space.x1, themeVars.space.x3),
  height: 28,
  borderRadius: themeVars.radius.pill,
  fontSize: themeVars.font.size.textMd,
  fontWeight: themeVars.font.weight.regular,
  width: 'fit-content',
});

export const boldChipClass = style({
  fontWeight: themeVars.font.weight.bold,
});

export const fixedWidthChipClass = style([
  textEllipsisClass,
  {
    width: 150,
  },
]);

export const squaredChipClass = style({
  height: 30,
  padding: nToPx(themeVars.space.x1, themeVars.space.x3),
  borderRadius: themeVars.radius.sm,
  fontSize: themeVars.font.size.textMd,
  fontWeight: themeVars.font.weight.regular,
});

export const chipVariantClass = styleVariants({
  [ChipVariant.BRAND]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.brand.secondary.x100,
      color: themeVars.colors.neutrals.white,

      selectors: {
        [`${clickableClass}&:hover`]: {
          backgroundColor: themeVars.colors.brand.secondary.x50,
        },
      },
    },
  ],
  [ChipVariant.BRAND_CONTRAST]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.brand.secondary.x100,
      color: themeVars.colors.neutrals.black100,

      selectors: {
        [`${clickableClass}&:hover`]: {
          backgroundColor: themeVars.colors.brand.secondary.x50,
        },
      },
    },
  ],
  [ChipVariant.LIGHT]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.neutrals.grey30,
      color: themeVars.colors.neutrals.black100,

      selectors: {
        [`${clickableClass}&:hover`]: {
          backgroundColor: themeVars.colors.neutrals.grey40,
        },
      },
    },
  ],
  [ChipVariant.DARK]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.neutrals.black100,
      color: themeVars.colors.neutrals.white,

      selectors: {
        [`${clickableClass}&:hover`]: {
          backgroundColor: themeVars.colors.neutrals.grey80,
        },
      },
    },
  ],
  [ChipVariant.INFO]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.status.info.x5,
      color: themeVars.colors.status.info.x100,

      selectors: {
        [`${clickableClass}&:hover`]: {
          backgroundColor: themeVars.colors.status.info.x10,
        },
      },
    },
  ],
  [ChipVariant.TERTIARY]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.brand.tertiary.x100,
      color: themeVars.colors.neutrals.white,

      selectors: {
        [`${clickableClass}&:hover`]: {
          backgroundColor: themeVars.colors.neutrals.grey30,
        },
      },
    },
  ],
  [ChipVariant.WARNING]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.status.warning.x5,
      color: themeVars.colors.status.warning.x100,

      selectors: {
        [`${clickableClass}&:hover`]: {
          backgroundColor: themeVars.colors.status.warning.x10,
        },
      },
    },
  ],
  [ChipVariant.SUCCESS]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.status.success.x5,
      color: themeVars.colors.status.success.x100,

      selectors: {
        [`${clickableClass}&:hover`]: {
          backgroundColor: themeVars.colors.status.success.x10,
        },
      },
    },
  ],
  [ChipVariant.ERROR]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.status.error.x5,
      color: themeVars.colors.status.error.x100,

      selectors: {
        [`${clickableClass}&:hover`]: {
          backgroundColor: themeVars.colors.status.error.x10,
        },
      },
    },
  ],
  [ChipVariant.YELLOW_LIGHT]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.neutrals.yellow5,
      color: themeVars.colors.neutrals.black100,
    },
  ],
  [ChipVariant.GREEN_LIGHT]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.brand.primary.x5,
      color: themeVars.colors.neutrals.black100,
    },
  ],
  [ChipVariant.BLUE_LIGHT]: [
    chipClass,
    {
      border: toBorder(themeVars.colors.brand.tertiary.x50),
      backgroundColor: themeVars.colors.brand.tertiary.x2,
      color: themeVars.colors.neutrals.black100,
    },
  ],
  [ChipVariant.PURPLE_LIGHT]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.brand.tertiary.x5,
      color: themeVars.colors.neutrals.black100,
    },
  ],
  [ChipVariant.DARK_LIGHT]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.neutrals.grey70,
      color: themeVars.colors.neutrals.white,
    },
  ],
  [ChipVariant.INFO_CONTRAST]: [
    chipClass,
    {
      backgroundColor: themeVars.colors.status.info.x10,
      color: themeVars.colors.neutrals.black100,
    },
  ],
});
